import {useEffect} from "react";
import {Button, Space} from "antd";
import {DownOutlined} from "@ant-design/icons";
import {AnimatePresence, motion} from "framer-motion";
import {StyledOfferingFormAccordionItemPanel} from "../style";
import {useOfferingFormAccordion} from "../../hooks/use-offering-form-accordion";
import {offeringFormAccordionReducer} from "../../reducers";
import {OfferingFormAccordionItemProps} from "../types";
import {OFFERING_FORM_ERROR_ATTRIBUTE} from "../scroll-to-first-error";

export function OfferingFormAccordionItem({
  index,
  title,
  children,
  isError,
  summary,
}: OfferingFormAccordionItemProps) {
  const {openIndexes, toggleIndex, openIndex} = useOfferingFormAccordion({
    reducer: offeringFormAccordionReducer,
  });
  const isOpen = openIndexes.includes(index);

  // A failed submit must never point at a section the coach cannot see. Sections only
  // open themselves here, never close, so this can't collapse something being edited.
  useEffect(() => {
    if (isError) {
      openIndex(index);
    }
  }, [isError, index, openIndex]);

  return (
    <div>
      <Space size={isOpen ? 16 : 0} direction="vertical" style={{display: "flex"}}>
        <StyledOfferingFormAccordionItemPanel
          {...{[OFFERING_FORM_ERROR_ATTRIBUTE]: isError ? "true" : undefined}}
          style={{
            border: isError ? "1px solid red" : "1px solid #f5f5f5",
          }}
          onClick={() => toggleIndex(index)}
        >
          <div>
            <p className="offering-form-accordion-item-panel-title">{title}</p>
            {/* Collapsed sections say what they already hold, so the coach doesn't have
                to open one to find out whether it needs their attention. */}
            {summary && !isOpen ? (
              <p className="offering-form-accordion-item-panel-summary">{summary}</p>
            ) : null}
          </div>
          <div>
            <Button
              type="text"
              // danger={isError}
              shape="circle"
              icon={<DownOutlined rotate={isOpen ? 0 : 180} />}
              size="small"
            />
          </div>
        </StyledOfferingFormAccordionItemPanel>
        <div>
          <AnimatePresence initial={false}>
            {isOpen && (
              <motion.div
                key="content"
                initial="collapsed"
                animate="open"
                exit="collapsed"
                style={{overflow: "visible"}}
                variants={{
                  open: {opacity: 1, height: "auto"},
                  collapsed: {opacity: 0, height: 0},
                }}
                transition={{duration: 0.3, ease: "linear"}}
              >
                <div>{children}</div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </Space>
    </div>
  );
}
